/* global axios */
import ApiClient from './ApiClient';

class TiktokAdsAPI extends ApiClient {
  constructor() {
    super('tiktok_ads_connections', { accountScoped: true });
  }

  // Returns the TikTok Marketing API OAuth URL to redirect the admin to.
  generateAuthorization() {
    return axios.post(`${this.baseUrl()}/tiktok_ads/authorization`);
  }

  // Lists the ad accounts (advertisers) the connection's token can access.
  advertisers(id) {
    return axios.get(`${this.url}/${id}/advertisers`);
  }

  // Persists which advertisers to collect for this connection.
  update(id, advertiserIds) {
    return axios.patch(`${this.url}/${id}`, { advertiser_ids: advertiserIds });
  }

  // Account-level advertiser list (for the report selector).
  accountAdvertisers() {
    return axios.get(`${this.baseUrl()}/tiktok_ads/advertisers`);
  }

  // Live campaign report for an advertiser + date preset.
  insights(advertiserId, datePreset) {
    return axios.get(`${this.baseUrl()}/tiktok_ads/insights`, {
      params: { advertiser_id: advertiserId, date_preset: datePreset },
    });
  }

  getAudiences() {
    return axios.get(`${this.baseUrl()}/tiktok_ads/audiences`);
  }

  createAudience(payload) {
    return axios.post(`${this.baseUrl()}/tiktok_ads/audiences`, payload);
  }

  syncAudience(id) {
    return axios.post(`${this.baseUrl()}/tiktok_ads/audiences/${id}/sync`);
  }

  deleteAudience(id) {
    return axios.delete(`${this.baseUrl()}/tiktok_ads/audiences/${id}`);
  }
}

export default new TiktokAdsAPI();
